import { Badge } from 'open-modules/cbcrc/component/badge';
import { component, demoFile } from 'system/demo';

demoFile('open-modules/cbcrc/component/badge');

component('Badge', Badge, {
    args: { imageUrl: 'https://placekitten.com/100/100' },
});
